module.exports = __webpack_public_path__ + "static/media/backArrow.8a852fb3.svg";